// DealStagePath — путь стадий сделки: кнопки всех стадий по STAGE_ORDER (U-19, sled-V9 W5).
// Текущая — подсвечена (contained + STAGE_COLORS); достижимые по матрице §8 (STAGE_TRANSITIONS)
// — кликабельны (outlined); недоступные — disabled/серые; клик по стадии → onSelect(next),
// смена стадии без модалки (вместо удалённого Dialog).
// MUI Stepper отклонён в ТЗ §5.1: матрица не линейна (rollback/lost/terminal) — кнопки-чипы
// покрывают и rollback, и потерянные ветки (канон Kanban crm-ux-research.md p52-53).
import { Button, Stack } from '@mui/material';
import type { DealStage } from '@/api/deals';
import { t } from '@/i18n';
import { formatStage } from '@/lib/format';
import { STAGE_ORDER, STAGE_COLORS } from '@/lib/dealStages';

export interface DealStagePathProps {
  /** Текущая стадия сделки. */
  stage: DealStage;
  /** Достижимые стадии из текущей (матрица §8: STAGE_TRANSITIONS[stage]). */
  transitions: DealStage[];
  /** Колбэк выбора перехода: next-стадия (не равна current). */
  onSelect: (next: DealStage) => void;
  /** Мутация смены стадии в полёте — переключатели заблокированы (U-24). */
  pending?: boolean;
}

/** Путь стадий сделки: наглядная смена стадии без диалога (U-19). */
export function DealStagePath({
  stage,
  transitions,
  onSelect,
  pending = false,
}: DealStagePathProps): JSX.Element {
  return (
    <Stack direction="row" spacing={1} alignItems="center" data-testid="deal-stage-path">
      {STAGE_ORDER.map((s) => {
        const isCurrent = s === stage;
        const reachable = transitions.includes(s);
        return (
          <Button
            key={s}
            size="small"
            variant={isCurrent ? 'contained' : 'outlined'}
            color={STAGE_COLORS[s]}
            // Недоступные (не текущая и не в матрице переходов) — серые disabled;
            // pending блокирует переключение до завершения мутации (U-24).
            disabled={pending || (!isCurrent && !reachable)}
            onClick={() => !isCurrent && onSelect(s)}
            aria-label={t('crm.deals.stagePath.aria', { stage: formatStage(s, t) })}
          >
            {formatStage(s, t)}
          </Button>
        );
      })}
    </Stack>
  );
}
